module.exports = __webpack_public_path__ + "img/icon-home-2.3ff1c875.svg";